'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n\twidth:100%;\n\n  &:after {\n    visibility: hidden;\n    display: block;\n    font-size: 0;\n    content: " ";\n    clear: both;\n    height: 0;\n  }\n  \n  display: inline-block;\n'], ['\n\twidth:100%;\n\n  &:after {\n    visibility: hidden;\n    display: block;\n    font-size: 0;\n    content: " ";\n    clear: both;\n    height: 0;\n  }\n  \n  display: inline-block;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Clearfix = _styledComponents2.default.div(_templateObject);

exports.default = Clearfix;